import React, { useEffect } from 'react'
import { Link, usePage, useForm } from '@inertiajs/react'

import { toast } from 'react-toastify'

import { Progress } from '@material-tailwind/react'

import Layout from '@/Shared/Layout'

import DesignationTable from '@/Pages/HR/Shared/DesignationTable'
import UserForm from '@/Pages/HR/Shared/UserForm'

const Create = () => {
  const { hr } = usePage().props

  const { data, setData, errors, post, progress, processing } = useForm({
    name: '',
    contact: '',
    designation: '',
    cnic: '',
    avatar: null,
    hr_id: hr.id
  })

  useEffect(() => {
    Object.values(errors).map(error => {
      toast.error(error)
    })
  }, [errors])

  function handleSubmit(e) {
    e.preventDefault()
    post(route('hr.user.store'))
  }

  return (
    <div>
      {progress && (
        <Progress
          value={progress.percentage}
          max="100"
          color="indigo"
          className="my-4"
        />
      )}

      <h1 className="mb-8 text-3xl font-bold">
        <Link
          onClick={() => history.back()}
          className="text-indigo-600 hover:text-indigo-700"
        >
          HR Designation
        </Link>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>

      <UserForm
        handleSubmit={handleSubmit}
        errors={errors}
        data={data}
        setData={setData}
        processing={processing}
      />

      <DesignationTable users={hr.users} id={hr.id} />
    </div>
  )
}

Create.layout = page => <Layout title="Add HR Designation" children={page} />

export default Create
